@if (!isLg()) {
  <div
    class="flex h-[4rem] w-min items-center justify-center space-x-[0.2rem] rounded-[1rem] bg-[#293366] px-[1.8rem] text-[1.2rem] font-400 leading-[1.6rem]"
  >
    <span class="text-[#6175A5]">ID</span>
    <span class="text-[#E1EAFF]">{{ withdrawal.id }}</span>
  </div>

  <div class="table__cell">
    <ng-container [ngTemplateOutlet]="methodCell"></ng-container>
  </div>

  <div class="table__cell">
    <ng-container [ngTemplateOutlet]="walletCell"></ng-container>
  </div>

  @if (withdrawal.amount) {
    <currency-input
      iconClass="text-[1.3rem] lg:text-[1.1rem] !text-[#FFC583]"
      valueClass="text-[1.3rem] font-400 text-[#FFC583]"
      [value]="withdrawal.amount"
    />
  } @else {
    <span></span>
  }

  <date-utc
    class="text-[1.3rem] font-325 leading-[1.6rem] text-[#9CB3ED]"
    [timestamp]="withdrawal.createdAt"
    format="HH:mm DD.MM.YY"
  />

  <div class="table__cell">
    <ng-container [ngTemplateOutlet]="statusCell"></ng-container>
  </div>
} @else {
  <div class="flex w-full justify-between">
    <div class="flex items-center justify-center space-x-[1rem]">
      <ng-container [ngTemplateOutlet]="methodCell"></ng-container>
      <div class="absolute left-[4.5rem]">
        <ng-container [ngTemplateOutlet]="walletCell"></ng-container>
      </div>
    </div>
    <div class="flex flex-col pr-[0.2rem] pt-[0.1rem] lg:items-end">
      <currency-input
        iconClass="text-[1rem] !text-[#FFC583]"
        valueClass="font-350 text-[#FFC583] text-[1rem] "
        [value]="withdrawal.amount"
      />
      <date-utc
        class="text-[1rem] font-325 leading-[1.2rem] text-[#9CB3ED]"
        [timestamp]="withdrawal.createdAt"
        format="HH:mm DD.MM.YY"
      />
    </div>
  </div>
  <div
    class="flex h-[4.2rem] w-full shrink-0 items-center justify-between rounded-[0.8rem] bg-[#293366] px-[1.2rem] py-[0.6rem] lg:px-[0.8rem]"
  >
    <div
      class="flex h-[4rem] w-min items-center justify-center space-x-[0.2rem] rounded-[1rem] bg-[#293366] px-[1.8rem] text-[1.2rem] font-400 leading-[1.6rem] lg:h-[2.8rem] lg:w-min lg:rounded-[0.6rem] lg:bg-[#32417B] lg:px-[1.2rem] lg:text-[1.1rem] lg:leading-[1.4rem]"
    >
      <span class="text-[#6175A5]">ID</span>
      <span class="text-[#E1EAFF]">{{ withdrawal.id }}</span>
    </div>
    <ng-container [ngTemplateOutlet]="statusCell"></ng-container>
  </div>
}

<ng-template #methodCell>
  <div class="h-[2.4rem] w-[2.4rem] overflow-hidden">
    @if (withdrawal.method.icon?.fileName) {
      <img class="image" alt="" [src]="withdrawal.method.icon!.fileName | withdrawalsMethodIconUrl" />
    }
  </div>
</ng-template>

<ng-template #walletCell>
  @if (item) {
    <div class="h-full w-[7.5rem] lg:w-[6rem]" [tp]="itemName" tpVariation="withdraw">
      <img class="image" [src]="item.id | itemImage" />
    </div>
    <ng-template #itemName>
      @if (isCsgoItem(item)) {
        <div class="flex space-x-[0.1rem]">
          <span>
            {{ item.extra.n[0] }}
          </span>

          <span>|</span>

          <span>
            {{ item.extra.n[1] }}

            @if (item.extra.n[2]) {
              ({{ item.extra.n[2] }})
            }
          </span>
        </div>
      } @else {
        <div class="text-[1.2rem] font-350 leading-[1.6rem] text-[#1C1C21]">
          {{ item.marketName }}
        </div>
      }
    </ng-template>
  }
  @if (cryptoItem?.address) {
    <div class="flex flex-col space-y-[0.2rem] justify-center items-start sm:space-y-0">
      <span (click)="copyAddress(cryptoItem?.address)" class="custom-transition-all text-[1.2rem] font-350 leading-[1.6rem] sm:text-[1.1rem] sm:leading-[1.4rem] text-[#CDDBFF] hover:opacity-60 cursor-pointer">{{  cryptoItem?.address?.slice(0, 8) + '...' + cryptoItem?.address?.slice(-8) }}</span>
      <span class="text-[#6983C8] text-[1rem] font-350 leading-[1.4rem] sm:leading-[1.2re]">{{ withdrawal.tokenInfo?.networkInformer || '' }}</span>
    </div>
  }

  @if (!item && !cryptoItem) {
    <div class="ml-[2rem] text-[1.2rem] font-350 leading-[1.4rem] lg:ml-[1rem]">-</div>
  }
</ng-template>

<ng-template #statusCell>
  <div class="flex items-center space-x-[1.4rem] lg:space-x-[1rem]">
    @if (withdrawal.canCancel) {
      <div class="flex items-center justify-center space-x-[0.5rem]">
        <button
          type="button"
          class="flex h-[3rem] w-[7.8rem] items-center justify-center rounded-[1.2rem] bg-[#3D497C] text-[#CDDBFF] custom-transition-all hover:bg-[#5967A1] hover:text-white"
          [disabled]="isCancelling()"
          [class.is-loading]="isCancelling()"
          (click)="cancelWithdrawal()"
        >
          <div class="text-[1.2rem] font-400 leading-[1.6rem]" i18n="@@profile.cancel_withdrawal">Отменить</div>
        </button>
      </div>
    }

    @if (tradeOfferUrl) {
      <a
        class="withdrawal__action withdrawal-action withdrawal-action_accept lg:px-[0]"
        target="_blank"
        [href]="tradeOfferUrl"
      >
        <div class="withdrawal-action__content" i18n="@@profile.receive">Принять</div>
      </a>
    }

    @if (countdown$ | async; as countdown) {
      <div class="withdrawal__action withdrawal-action withdrawal-action_timer">
        <div class="withdrawal-action__content">
          {{ countdown }}
        </div>
      </div>
    }

    <div class="flex items-center justify-center space-x-[0.4rem]">
      <span class="text-right text-[1.2rem] font-400 leading-[1.6rem] lg:text-[1.1rem]">
        @switch (withdrawal.status) {
          @case (1) {
            <span class="text-[#4E9BFF]">Created</span>
          }
          @case (2) {
            <span class="text-[#CDDBFF]">On Hold</span>
          }
          @case (3) {
            <span class="text-[#FFCF91]">Processing</span>
          }
          @case (4) {
            <span class="text-[#6DEA5D]">Done</span>
          }
          @case (5) {
            <span class="text-[#F85769]">Refunded</span>
          }
        }
      </span>

      @switch (withdrawal.status) {
        @case (WithdrawalStatus.DONE) {
          <div class="withdrawal__status withdrawal__status_success"></div>
        }
        @case (WithdrawalStatus.ON_HOLD) {
          <div
            class="withdrawal__status withdrawal__status_awaiting"
            i18n-tp="@@profile.hold_item_tooltip"
            tpVariation="withdraw"
            tpMaxWidth="230px"
            tp="Ваш вывод попал на проверку. Это займет до 15 минут"
          ></div>
        }
        @case (WithdrawalStatus.PROCESSING) {
          <div
            class="withdrawal__status withdrawal__status_trade-sent"
            tpVariation="withdraw"
            [tp]="statusTooltip"
            [tpIsEnabled]="!!statusTooltip"
            tpMaxWidth="230px"
          ></div>
        }
        @case (WithdrawalStatus.CREATED) {
          <div
            class="withdrawal__status withdrawal__status_pending"
            tpVariation="withdraw"
            [tp]="statusTooltip"
            [tpIsEnabled]="!!statusTooltip"
            tpMaxWidth="230px"
          ></div>
        }
        @case (WithdrawalStatus.REFUNDED) {
          <div
            class="withdrawal__status withdrawal__status_warning"
            tp="Вывод неуспешен. Средства были возвращены на баланс"
            [tp]="message"
            tpVariation="withdraw"
            i18n-tp="@@profile.withdrawal_refunded"
            tpMaxWidth="230px"
          ></div>
        }
      }

      <ng-template #message>
        @if (withdrawal.errorText) {
          {{ withdrawal.errorText }}
        } @else {
          <span>Вывод неуспешен. Средства были возвращены на баланс</span>
        }
      </ng-template>
    </div>
  </div>
</ng-template>
